<template>
  <div>
    <div class="single-review py-16 border-bottom-stroke-dark-soft">
      <div class="grid-row grid-row_md">
        <div class="grid-col grid-col_full">
          <div class="fw-medium">
            {{ reviewName }}
          </div>
        </div>

        <div class="grid-col">
          <div class="color-gray">
            {{ reviewDate }}
          </div>
        </div>
      </div>

      <div class="mt-8">
        <Rating :rating-count="reviewRating" />
      </div>

      <!-- <div class="grid-row d-flex_middle grid-row_sm mt-8">
        <div class="grid-col">
          <span class="color-caption-soft">Отзыв с сайта Lamoda</span>
        </div>
        <div class="grid-col">
          <div class="icon-20">
            <img
              class="img-cover"
              src="./../../assets/images/logo-lamoda.svg"
              alt="logo"
            />
          </div>
        </div>
      </div>-->

      <!-- выводить полный текст, скрываю и показываю стилями -->
      <div
        class="single-review__text mt-16"
        v-bind:class="{ 'is-show': isActive }"
      >
        <div
          class="color-caption-soft"
          v-html="textCut(reviewText, 220)"
          v-show="!isActive"
        ></div>
        <div
          class="color-caption-soft"
          v-html="reviewText"
          v-show="isActive"
        ></div>
      </div>

      <!-- если длинный текст -->
      <div class="mt-8" v-if="reviewText.length > 220">
        <div class="btn color-tertiary hover-color-dark" @click="toggleState()">
          <span class="d-block" v-if="isActive">Свернуть</span>
          <span class="d-block" v-else>Читать полностью</span>
          <Icon
            iconName="icon-chevron-down"
            className="ml-8 icon-16 active-rotate-180"
            v-bind:class="{ 'is-active': isActive }"
          />
        </div>
      </div>

      <!-- если есть картинки -->
      <div class="single-review__images mt-8" ref="container">
        <div class="grid-row grid-row_sm">
          <div
            class="grid-col pt-8"
            v-for="(picture, index) in reviewPictures"
            :key="index"
          >
            <a
              :href="picture.full"
              data-fancybox="gallery-review"
              class="single-review__preview btn icon-40"
            >
              <img class="img-cover" :src="picture.preview" alt="product" />
            </a>
          </div>
        </div>
      </div>
    </div>

    <div v-if="reviewAnswer?.length > 0">
      <Answer :text="reviewAnswer" />
    </div>
  </div>
</template>

<script>
import Rating from "../Rating/Rating.vue";
import Answer from "../Answer/Answer.vue";
import Icon from "../Icon/Icon.vue";
import { textCut } from "@/pages/product_card/tools/functions";

export default {
  name: "SingleReviewShort",
  components: {
    Rating,
    Answer,
    Icon,
  },
  props: {
    options: Object,
    reviewName: {
      type: String,
      default: "",
    },
    reviewDate: {
      type: String,
      default: "",
    },
    reviewText: {
      type: String,
      default: "",
    },
    reviewAnswer: {
      type: String,
      default: "",
    },
    reviewAnswerCut: {
      type: Boolean,
      default: false,
    },
    reviewTextCut: {
      type: Boolean,
      default: false,
    },
    reviewRating: {
      type: Number,
      default: 4,
    },
    reviewPictures: {
      type: Array,
    },
  },
  data() {
    return {
      isActive: false,
    };
  },
  methods: {
    toggleState() {
      this.isActive = !this.isActive;
    },
    textCut(text, limit) {
      return textCut(text, limit);
    },
  },
};
</script>

<style lang="scss">
@import "./single-review.scss";
</style>
